// extracted by mini-css-extract-plugin
export var table = "_tp-0";